var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }
  return cooked;
};
import React from 'react';
import styled, { css } from 'styled-components';
import { breakpoints, theme } from '@shapeable/theme';
import { classNames } from '@shapeable/utils';
import { useComponentProps } from '../context/component-props-context';
import { useThemeEval } from '../hooks/use-theme-eval';
import { useSpringValues } from '../hooks/use-spring-values';
import { animated, to } from '@react-spring/web';
import { opacityToHex } from '../utils/opacity-to-hex';
var cls = classNames('backdrop');
export var BackdropDefaultProps = {
  color: 'strong-chrome',
  opacity: 0.7,
  zIndex: 600,
  springConfig: {
    duration: 100
  },
  from: {
    opacity: 0
  }
};
// -------- Styles -------->
var ContainerStyles = breakpoints({
  base: css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    position: fixed;\n    width: 100vw;\n    height: 100vh;\n  "], ["\n    position: fixed;\n    width: 100vw;\n    height: 100vh;\n  "])))
});
// -------- Components -------->
var My = {
  NAME: 'Backdrop',
  Container: styled(animated.div)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["", ""], ["", ""])), ContainerStyles)
};
export var Backdrop = function (props) {
  var componentProps = useComponentProps(My.NAME, BackdropDefaultProps, props);
  var className = componentProps.className,
    children = componentProps.children,
    zIndex = componentProps.zIndex;
  var $ = useThemeEval();
  var color = $(theme.COLOR(componentProps.color));
  var opacity = useSpringValues(componentProps).opacity;
  var backgroundColor = function (opacity) {
    return "".concat(color).concat(opacityToHex(opacity));
  };
  return React.createElement(My.Container, {
    style: {
      zIndex: zIndex,
      backgroundColor: to([opacity], backgroundColor)
    },
    className: cls.name(className)
  }, children);
};
Backdrop.cls = cls;
var templateObject_1, templateObject_2;